import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { StorageService } from '@shared/services';
import { NotificationService } from '@shared/services/dialogs/notification.service';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { TranslateService } from '@shared/services/translate';
import { Md5 } from 'ts-md5/dist/md5';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
    selector: 'shopbox-screen-locker-sheet',
    templateUrl: './screen-locker-sheet.component.html',
    styleUrls: ['./screen-locker-sheet.component.scss'],
    imports: [FormsModule, MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatIcon, MatSuffix, MatError, MatIconButton, TranslatePipe]
})
export class ScreenLockerSheetComponent {
  staff: any[] = [];
  result: any;
  pinCodeCtrl: UntypedFormControl = new UntypedFormControl();

  icon: string = 'visibility';
  type: string = 'password';

  constructor(
    private _changeDetectRef: ChangeDetectorRef,
    private _bottomSheetRef: MatBottomSheetRef<ScreenLockerSheetComponent>,
    private _storage: StorageService,
    public translate: TranslateService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any[]
  ) { 
    this.staff = data;
    //@TODO: IF No Staff Get Staff pls
  }

  findCode() {
    const hashMd5: Md5 = new Md5();
    const hashCode =  Md5.hashStr(this.pinCodeCtrl.value);
    this.pinCodeCtrl.disable();
    hashMd5.end();
    const index = this.staff.findIndex(element => element.code === hashCode);
    if (index !== -1) {
      this.result = {
        result: true,
        staff: this.staff[index],
        pinCode: this.pinCodeCtrl.value
      };
      this.hide(true);
    } else {
      this.pinCodeCtrl.enable();
      this.pinCodeCtrl.updateValueAndValidity();
      this.pinCodeCtrl.setErrors({notExist: true});
      this._changeDetectRef.markForCheck();
    }
  }

  hide(save?: boolean) {
    if (save) {
      this._storage.deleteLockerScreen();
      this._bottomSheetRef.dismiss(this.result);
    } else {
      this._bottomSheetRef.dismiss();
    }
  }

  toggleVisiblity(event: MouseEvent) {
    event.stopPropagation();
    this.type = this.type === 'text' ? 'password' : 'text';
    this.icon = this.icon === 'visibility' ? 'visibility_off': 'visibility';
  }
}
